<template>
  <v-row v-if="view" class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row align="center" justify="center" style="height:60px;">
            <v-col cols="6" class="pa-0" align="center">
              <v-row align="center" justify="start" class="ma-0 pa-0">
                <v-col cols="4" class="pa-0" align="center">
                  <v-btn :outlined="metric != 1" depressed color="primary" @click="metric = 1" class="ma-1 span"><span class="caption font-weight-bold">生徒</span></v-btn>
                  <v-btn :outlined="metric != 2" depressed color="primary" @click="metric = 2" class="ma-1 span"><span class="caption font-weight-bold">外部</span></v-btn>
                  <v-btn :outlined="metric != 3" depressed color="primary" @click="metric = 3" class="ma-1 span"><span class="caption font-weight-bold">内部</span></v-btn>
                </v-col>
                <v-col class="pa-0" align="center">
                  <v-select
                    :items="$YEARS"
                    label="年度"
                    hideDetails
                    v-model.number="year"
                    class="pr-1"
                    item-text="name"
                    item-value="value"
                  ></v-select>
                </v-col>
                <v-col class="pa-0" align="center">
                  <v-select
                    v-if="year == getFY()"
                    :items="compares"
                    label="対比"
                    v-model="compare"
                    class="pr-1"
                    hideDetails
                  ></v-select>
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                  <v-select
                    v-if="compare != 'N/A' && !viewType && year == getFY()"
                    :items="indicators"
                    label="指標"
                    v-model="indicator"
                    class="pr-1"
                    hideDetails
                  ></v-select>
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                  <template v-if="metric == 1">
                    <v-btn depressed color="primary" @click="viewType = !viewType" class="ma-1 span">
                      <span v-if="viewType" class="caption font-weight-bold">数値</span>
                      <v-icon v-else small>mdi-chart-bar</v-icon>
                    </v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-row align="center" justify="start" class="ma-0 pa-0">
                <v-col cols="10" class="pa-0" align="center">
                  <v-select
                    class="pr-1"
                    :items='tempGroups'
                    label='教室'
                    v-model='group'
                    item-text="name"
                    item-value="key"
                    multiple
                    hideDetails
                    small-chips
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="2" class="pa-0" align="center">
                  <v-btn dark rounded depressed small color="error" @click="onRefreshDialog = true">
                    <span class="text-none">再計算</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <keep-alive>
            <app-metrics-students
              v-if="metric == 1"
              :year="year"
              :group="group"
              :tempGroups="tempGroups"
              :compare="compare"
              :indicator="indicator"
              :items="acts"
              :plans="plans"
              :status="status"
              :diffs="diffs"
              :diffsRevises="diffsRevises"
              :inout="inout"
              :revices="revices"
              :viewType="viewType"
            >
            </app-metrics-students>
          </keep-alive>
          <keep-alive>
            <app-metrics-outside
              v-if="metric == 2"
              :year="year"
              :group="group"
              :tempGroups="tempGroups"
              :compare="compare"
              :indicator="indicator"
              :viewType="viewType"
              :plans="plans"
              :status="status"
              :diffs="statusDiffs"
              :kpidata="okpidata"
              :diffkpidata="diffkpidata"
              :sColor="'#00ff0030'"
            >
            </app-metrics-outside>
          </keep-alive>
          <keep-alive>
            <app-metrics-inside
              v-if="metric == 3"
              :view="view"
              :g="g"
              :m="mm"
              :year="year"
              :group="group"
              :tempGroups="tempGroups"
              :compare="compare"
              :indicator="indicator"
              :acts="acts"
              :plans="plans"
              :status="status"
              :diffs="statusDiffs"
              :totalTygs="totalTygs"
              :kpis="kpis"
              :ycss="ycss"
              :ycsdata="ycsdata"
              :kpidata="kpidata"
              :viewType="viewType"
              :sColor="'#00ff0030'"
            >
            </app-metrics-inside>
          </keep-alive>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="'再計算'"
        :message="'再計算が完了するまでブラウザを閉じずにそのままお待ちください。よろしいですか？'"
        :dialog='onRefreshDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

  </v-row>
  <v-row v-else class="ma-0" align="center">
   <template v-if="type == 'metric'">
      <v-col cols="12" class="pa-0" align="center">
        <v-row class="ma-0 pa-0" align="start"  justify="start" style="height: 70px;">
          <v-col cols="2" align="center" class="pa-0">
            <v-card flat tile height="70" class="title-blue">
              <v-sheet tile color="primary" class="caption white--text select-none">生徒数</v-sheet>
              <v-card-text class="pa-0">
                <span class="display-2 black--text clickable" @click="onShowStudents(acts[g][mm][17])">{{ acts[g][mm][17].length }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2" align="center" class="pa-0">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="pa-0">
                <v-card flat tile height="70" class="title-green">
                  <v-sheet tile color="success" class="caption white--text select-none">目標</v-sheet>
                  <v-card-text class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="12" class="pa-0">
                        <span class="body-1 black--text select-none">{{ plans[g][mm][17].value }}</span>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="end">
                        <span class="caption black--text select-none">{{ calcDiv(acts[g][mm][17].length, plans[g][mm][17].value) }}</span>
                        <span>%</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-card flat tile height="70" class="title-grey">
                  <v-sheet tile color="grey" class="caption white--text select-none">昨年</v-sheet>
                  <v-card-text class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="12" class="pa-0">
                        <span class="body-1 black--text select-none">{{ getPrev(g, mm) }}</span>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="end">
                        <span class="caption black--text select-none">{{ calcDiv(acts[g][mm][17].length, getPrev(g, mm)) }}</span>
                        <span>%</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" align="center" justify="start" class="pa-0">
            <v-row class="ma-0 pa-0">
              <!-- <template v-for="(item, index) in insideKpis"> -->
                <v-col cols="4" class="pa-0" v-for="(item, index) in insideKpis" :key="index">
                  <v-card flat tile height="70" class="title-blue">
                    <v-sheet tile color="primary" class="caption white--text select-none" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;">{{ item.title }}</v-sheet>
                    <v-card-text class="pa-0">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <template>
                            <span class="body-1 black--text clickable" @click="onShowStudents(status[g][mm][item.index])">{{ status[g][mm][item.index].length }}</span>
                          </template>
                        </v-col>
                        <v-col v-if="item.index != 1" cols="12" class="pa-0" align="end">
                          <span class="caption black--text select-none">{{ calcDiv(status[g][mm][item.index].length, acts[g][mm][17].length) }}</span>
                          <span>%</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              <!-- </template> -->
            </v-row>
          </v-col>
          <v-col cols="2" align="center" class="pa-0">
            <v-row class="ma-0 pa-0">
              <v-col cols="4" align="center" class="pa-0">
                <v-card flat tile height="70" class="title-blue">
                  <v-sheet tile color="primary" class="caption white--text select-none overflow-text-hidden">
                    問合せ
                  </v-sheet>
                  <v-card-text class="pa-0 pt-1">
                    <span class="headline black--text clickable" @click="onShowStudents(status[g][mm][1])">{{ status[g][mm][1].length }}</span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4" align="center" class="pa-0">
                <v-card flat tile height="70" class="title-blue">
                  <v-sheet tile color="primary" class="caption white--text select-none overflow-text-hidden">
                    {{ extension == 1 ? '入会数' : '入塾数' }}
                  </v-sheet>
                  <v-card-text class="pa-0 pt-1">
                    <span class="headline black--text clickable" @click="onShowStudents(status[g][mm][5])">{{ status[g][mm][5].length }}</span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4" align="center" class="pa-0">
                <v-card flat tile height="70" class="title-orange">
                  <v-sheet tile color="error" class="caption white--text select-none overflow-text-hidden">
                    {{ extension == 1 ? '退会数' : '退塾数' }}
                  </v-sheet>
                  <v-card-text class="pa-0 pt-1">
                    <span class="headline clickable" @click="onShowStudents(inout[g][mm][17][1])">{{ inout[g][mm][17][1].length }}</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" align="center" class="pa-0">
            <v-row class="ma-0 pa-0">
              <!-- <template v-for="(item, index) in ycsKpis"> -->
                <v-col cols="3" class="pa-0" v-for="(item, index) in ycsKpis" :key="index">
                  <v-card flat tile height="70" class="title-blue">
                    <v-sheet tile color="primary" class="caption white--text select-none">{{ item.title }}</v-sheet>
                    <v-card-text class="pa-0">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <span class="body-1 black--text clickable" @click="onShowStudents(acts[g][mm][item.index])">{{ acts[g][mm][item.index].length }}</span>
                        </v-col>
                        <v-col cols="12" class="pa-0" align="end">
                          <span class="caption black--text select-none">{{ calcDiv(acts[g][mm][item.index].length, acts[g][mm][17].length) }}</span>
                          <span>%</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              <!-- </template> -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
   </template>
  <template v-else-if="type == 'bar'">
    <v-sheet width="100%">
      <template-metrics-graph
        :type="'enrollment'"
        :height="300"
        :group="g"
        :tempGroups="tempGroups"
        :compare="'N/A'"
        :items="acts"
        :revices="revices"
        :year="yyyy"
      >
      </template-metrics-graph>
    </v-sheet>
  </template>
  <template v-else-if="type == 'pie'">
    <v-sheet width="100%">
      <template-metrics-graph
        :type="'pie'"
        :height="300"
        :group="g"
        :tempGroups="tempGroups"
        :compare="'N/A'"
        :items="acts"
        :revices="revices"
        :mm="mm"
        :year="yyyy"
      >
      </template-metrics-graph>
    </v-sheet>
  </template>

    <div>
      <v-dialog v-model="listDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-list-dialog
          v-if="listDialog"
          @dismissed="onDismissed"
          :selected="selected"
        >
        </app-list-dialog>
      </v-dialog>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import Students from './MetricsStudents.vue'
import Outside from './MetricsOutside.vue'
import Inside from './MetricsInside.vue'
import ListDialog from '../../components/student/ListDialog.vue'
Vue.component('app-metrics-students', Students)
Vue.component('app-metrics-outside', Outside)
Vue.component('app-metrics-inside', Inside)
Vue.component('app-list-dialog', ListDialog)
export default {
  data () {
    return {
      loading: false,
      listDialog: false,
      onRefreshDialog: false,
      metric: 1,
      tempGroups: [],
      group: [],
      year: this.getFY(),
      compare: 'N/A',
      indicators: [ '数値', '%' ],
      indicator: '数値',
      acts: {},
      revices: {},
      prev: {},
      prevRevices: {},
      plans: {},
      status: {},
      inout: {},
      inoutDiffs: {},
      diffs: {},
      diffsRevises: {},
      statusDiffs: {},
      totalTygs: {},
      viewType: false,
      kpis: [
        { key: 1, name: 'DTS率', tips: 'DTS人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 2, name: '生徒面談率', tips: '生徒面談人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 3, name: '保護者面談率', tips: '保護者面談人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      ycss: [
        { key: 1, name: '◎', tips: '◎ 人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 2, name: '◯', tips: '◯ 人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 3, name: '△', tips: '△ 人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 4, name: 'Ｘ', tips: 'Ｘ 人数 ÷ 在籍人数', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      kpidata: {},
      ycsdata: {},
      okpidata: {},
      diffkpidata: {},
      insideKpis: [
        { title: 'DTS', index: 9 },
        { title: '生徒面談', index: 10 },
        { title: '保護者面談', index: 11 }
      ],
      ycsKpis: [
        { title: 'Ｘ', index: 21 },
        { title: '△', index: 20 },
        { title: '◯', index: 19 },
        { title: '◎', index: 18 }
      ],
      selected: null
    }
  },
  props: [ 'view', 'type', 'g', 'mm', 'yyyy' ],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      privilege: 'shared/privilege',
      metricsActs: 'metricsActs/metrics',
      metricsPlans: 'metricsPlans/metrics',
      metricsStatus: 'metricsStatus/metrics',
      metricsRevises: 'metricsRevises/metrics',
      students: 'students/students',
      planHeaders: 'metricsPlans/headers',
      preschool: 'shared/preschool',
      extension: 'shared/extension'
    }),
    compares () {
      var temp = [ 'N/A', '目標' ]
      if (this.year < this.getFY()) {
        return temp
      }
      if (this.year === this.getFY()) {
        for (var i in this.$YEARS) {
          if (this.$YEARS[i].value < this.getFY()) {
            temp.push(this.$YEARS[i].name)
          }
        }
      }
      return temp
    }
  },
  watch: {
    groups () {
      this.createGroups()
      this.createData()
    },
    schools () {
      this.createGroups()
    },
    data () {
      this.createGroups()
    },
    privilege () {
      this.createGroups()
    },
    year () {
      if (this.year !== this.getFY()) {
        this.compare = 'N/A'
        this.indicator = '数値'
      }
      this.createData()
    },
    metricsActs () {
      this.createData()
    },
    metricsPlans () {
      this.createData()
    },
    metricsRevises () {
      this.createData()
    },
    metricsStatus () {
      this.createData()
    },
    compare () {
      if (this.compare === 'N/A') {
        this.indicator = '数値' // When return to the 'N/A', set the indicator to '数値', to prevent error
      }
      if (this.compare !== 'N/A' && this.compare !== '目標') {
        this.statusDataRead(parseInt(this.compare), 1)
        this.calcKpisDiffs()
      }
      this.diffRead()
    },
    yyyy () {
      this.year = this.yyyy
    }
  },
  async created () {
    this.createGroups()
    this.createData()
    this.actsRead(this.getFY() - 1, 1)
  },
  methods: {
    createData () {
      this.actsRead(this.year, 0)
      this.statusDataRead(this.year, 0)
      this.planDataRead()
      this.calcTygTotal()
      this.calcKpis()
    },
    createGroups () {
      this.tempGroups = []
      this.group = []
      if (!this.data) {
        return
      }
      if (this.getPrivilegesLevel(this.data) < 2) {
        this.tempGroups.push({ name: '全校', key: '*' })
      }
      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          if (typeof this.data.primaryGroup === 'undefined' || this.data.primaryGroup === null) {
            this.group.push(this.tempGroups[0].key)
          } else {
            for (var x in this.tempGroups) {
              if (this.tempGroups[x].key === this.data.primaryGroup) {
                this.group.push(this.data.primaryGroup)
                break
              }
            }
          }
        }
      } else {
        var school = this.getPrimary()
        if (school !== null) {
          keys = Object.keys(school.groups)
          for (i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
          if (this.tempGroups.length !== 0) {
            this.group.push(this.tempGroups[0].key)
          }
        }
      }
    },
    calcDiv (num, dem) {
      var r = Math.floor((num / dem) * 100)
      r = isNaN(r) || r === Infinity ? 0 : r
      return r
    },
    getPrev (g, mm) {
      if (typeof this.prev[g] === 'undefined' && typeof this.prevRevices[g] === 'undefined') {
        return 0
      }
      if (typeof this.prevRevices[g] !== 'undefined' && this.prevRevices[g][mm].enable) {
        return this.prevRevices[g][mm][17].value
      }
      if (typeof this.prev[g] !== 'undefined') {
        return this.prev[g][mm][17].length
      }
      return 0
    },
    onRefresh () {
      var vm = this
      this.acts = {}
      this.plans = {}
      this.status = {}
      this.diffs = {}
      if (this.data) {
        this.loading = true
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(school => school.key === keys[i])
            const functions = firebase.app().functions('asia-northeast1')
            const checkEnrolled = functions.httpsCallable('checkEnrolled')
            checkEnrolled(this.schools[index]).then(function (result) {
              vm.createData()
              vm.loading = false
            })
          }
        }
      }
    },
    actsRead (year, type) {
      this.reviseRead(year, type)
      var temp = {}
      for (var i in this.tempGroups) {
        for (var x = 0; x < 12; x++) {
          temp[this.tempGroups[i].key] = [
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
          ]
        }
      }
      var acts = this.metricsActs.filter(function (metric) {
        return metric.yyyy === year
      })
      var counter = (this.preschool && this.extension === 1) ? 31 : 23
      for (i in acts) {
        for (var y = 0; y < counter; y++) {
          for (var item in acts[i][y]) {
            var keys = Object.keys(acts[i][y][item].groups)
            for (var k in keys) {
              if (acts[i][y][item].groups[keys[k]] && this.checkValidGroup(keys[k])) {
                temp[keys[k]][acts[i].mm][y].push(acts[i][y][item])
              }
            }
            if (this.data.role === 'admin' || this.data.role === 'owner') {
              temp['*'][acts[i].mm][y].push(acts[i][y][item])
            }
          }
        }
      }
      if (type === 0) {
        this.acts = temp
      } else {
        this.prev = temp
      }
      // this.reviseRead(year, type)
    },
    reviseRead (year, type) {
      var revices = this.metricsRevises.filter(function (metric) {
        return metric.year === year
      })
      var school = this.getPrimary()
      if (!school) {
        return
      }
      var from = 0
      var to = 0
      if (school.preschool) {
        if (school.extension === 1) {
          from = 1
          to = 31
        } else {
          from = 0
          to = 18
        }
      } else {
        from = 1
        to = 18
      }
      var temp = {}
      for (var i in revices) {
        var keys = Object.keys(revices[i].groups)
        for (var k in keys) {
          if (revices[i].groups[keys[k]]) {
            temp[keys[k]] = JSON.parse(JSON.stringify(revices[i]))
          }
        }
        if (typeof temp['*'] === 'undefined') {
          temp['*'] = JSON.parse(JSON.stringify(revices[i]))
          for (var x = 0; x < 12; x++) {
            if (revices[i][x].enable) {
              for (var y = from; y < to; y++) {
                if (typeof temp['*'][x][y] !== 'undefined') {
                  temp['*'][x][y].value = 0
                }
              }
            }
          }
        }
        for (x = 0; x < 12; x++) {
          if (revices[i][x].enable) {
            for (y = from; y < to; y++) {
              if (typeof revices[i][x][y] !== 'undefined') {
                temp['*'][x][y].value += revices[i][x][y].value
              }
            }
            if (revices[i][x].enable) {
              temp['*'][x].enable = true
            }
          }
        }
      }
      if (type === 0) {
        this.revices = temp
      } else {
        this.prevRevices = temp
      }
    },
    planDataRead () {
      var metric = null
      var vm = this
      for (var g in this.tempGroups) {
        var index = this.metricsPlans.findIndex(plan => plan.groups[this.tempGroups[g].key] && plan.year === this.year)
        if (index !== -1) {
          var temp = this.metricsPlans.filter(function (plan) {
            if (plan.groups[vm.tempGroups[g].key] && plan.year === vm.year) {
              return true
            }
            return false
          })
          metric = JSON.parse(JSON.stringify(temp[0]))
          for (var i = 0; i < 12; i++) {
            for (var x = 0; x < this.planHeaders.length; x++) {
              if (typeof metric[i][this.planHeaders[x].key] !== 'undefined') {
                metric[i][this.planHeaders[x].key].modify = false
              } else {
                metric[i][this.planHeaders[x].key] = {
                  value: 0,
                  modify: false
                }
              }
            }
          }
        } else {
          metric = JSON.parse(JSON.stringify(this.$store.getters['metricsPlans/initial']))
          for (i = 0; i < 12; i++) {
            for (x = 0; x < this.planHeaders.length; x++) {
              metric[i][this.planHeaders[x].key] = {
                value: 0,
                modify: false
              }
            }
          }
        }
        Vue.set(this.plans, this.tempGroups[g].key, JSON.parse(JSON.stringify(metric)))
      }
      var divider = []
      for (var zz = 0; zz < 12; zz++) {
        divider[zz] = new Array(this.planHeaders.length).fill(0)
      }
      if (this.data && (this.data.role === 'admin' || this.data.role === 'owner')) {
        if (typeof this.tempGroups['*'] === 'undefined') {
          for (g in this.tempGroups) {
            if (this.tempGroups[g].key !== '*') {
              for (i = 0; i < 12; i++) {
                for (x = 0; x < this.planHeaders.length; x++) {
                  this.plans['*'][i][this.planHeaders[x].key].value += this.plans[this.tempGroups[g].key][i][this.planHeaders[x].key].value
                  if (this.planHeaders[x].key > 90 && this.planHeaders[x].key < 200) {
                    if (this.plans[this.tempGroups[g].key][i][this.planHeaders[x].key].value !== 0) {
                      divider[i][this.planHeaders[x].key - 100] += 1
                    }
                  }
                }
              }
            }
          }
          for (i = 0; i < 12; i++) {
            for (x = 0; x < this.planHeaders.length; x++) {
              if (this.planHeaders[x].key >= 100 && this.planHeaders[x].key < 200) {
                var r = Math.floor(this.plans['*'][i][this.planHeaders[x].key].value / divider[i][this.planHeaders[x].key - 100])
                r = isNaN(r) || r === Infinity ? 0 : r
                this.plans['*'][i][this.planHeaders[x].key].value = r
              }
            }
          }
        }
      }
    },
    statusDataRead (yyyy, type) {
      var temp = {}
      var tempio = {}
      for (var i in this.tempGroups) {
        for (var x = 0; x < 12; x++) {
          temp[this.tempGroups[i].key] = [
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
          ]
          tempio[this.tempGroups[i].key] = [
            //   0         1         2         3         4         5         6         7         8         9        10        11        12        13        14        15        16        17        18        19        20        21        22        23        24        25        26        27        28        29        30
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]],
            [[[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []], [[], []]]
          ]
        }
      }
      var stats = this.metricsStatus.filter(function (metric) {
        return metric.yyyy === yyyy
      })
      for (i in stats) {
        for (x = 1; x < 16; x++) {
          var dup = {}
          var dupA = {}
          if (typeof stats[i][x] !== 'undefined') {
            for (var y in stats[i][x]) {
              var keys = Object.keys(stats[i][x][y].groups)
              for (var k in keys) {
                if (stats[i][x][y].groups[keys[k]] && this.checkValidGroup(keys[k])) {
                  if (!dup[stats[i][x][y].key]) {
                    dup[stats[i][x][y].key] = true
                    temp[keys[k]][stats[i].mm][x].push(stats[i][x][y])
                    if (x === 5) {
                      tempio[keys[k]][stats[i].mm][stats[i][x][y].grade][0].push(stats[i][x][y])
                      if (stats[i][x][y].grade !== 0) {
                        tempio[keys[k]][stats[i].mm][this.getOffset(stats[i][x][y].grade)][0].push(stats[i][x][y])
                      }
                      tempio[keys[k]][stats[i].mm][17][0].push(stats[i][x][y])
                    }
                    if (x === 7) {
                      tempio[keys[k]][stats[i].mm][stats[i][x][y].grade][1].push(stats[i][x][y])
                      if (stats[i][x][y].grade !== 0) {
                        tempio[keys[k]][stats[i].mm][this.getOffset(stats[i][x][y].grade)][1].push(stats[i][x][y])
                      }
                      tempio[keys[k]][stats[i].mm][17][1].push(stats[i][x][y])
                    }
                  }
                }
              }
              if (this.data && (this.data.role === 'admin' || this.data.role === 'owner')) {
                if (!dupA[stats[i][x][y].key] && this.checkValidGroup(keys[k])) {
                  dupA[stats[i][x][y].key] = true
                  temp['*'][stats[i].mm][x].push(stats[i][x][y])
                  if (x === 5) {
                    tempio['*'][stats[i].mm][stats[i][x][y].grade][0].push(stats[i][x][y])
                    if (stats[i][x][y].grade !== 0) {
                      tempio['*'][stats[i].mm][this.getOffset(stats[i][x][y].grade)][0].push(stats[i][x][y])
                    }
                    tempio['*'][stats[i].mm][17][0].push(stats[i][x][y])
                  }
                  if (x === 7) {
                    tempio['*'][stats[i].mm][stats[i][x][y].grade][1].push(stats[i][x][y])
                    if (stats[i][x][y].grade !== 0) {
                      tempio['*'][stats[i].mm][this.getOffset(stats[i][x][y].grade)][1].push(stats[i][x][y])
                    }
                    tempio['*'][stats[i].mm][17][1].push(stats[i][x][y])
                  }
                }
              }
            }
          }
        }
      }
      if (type === 0) {
        this.status = temp
        this.inout = tempio
      } else {
        this.statusDiffs = temp
        this.inoutDiffs = tempio
      }
    },
    getOffset (grade) {
      var offset = 0
      if (grade >= 7 && grade <= 9) {
        offset = 1
      } else if (grade >= 10 && grade < 23) {
        offset = 2
      } else if (grade >= 23) {
        return 30
      }
      return offset + 14
    },
    diffRead () {
      if (this.compare === 'N/A' || this.compare === '目標') {
        this.diffs = {}
        return
      }
      var vm = this
      var temp = {}
      for (var i in this.tempGroups) {
        for (var x = 0; x < 12; x++) {
          temp[this.tempGroups[i].key] = [
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
          ]
        }
      }
      var acts = this.metricsActs.filter(function (metric) {
        return metric.yyyy === Number(vm.compare)
      })
      var counter = (this.preschool && this.extension === 1) ? 31 : 18
      for (i in acts) {
        for (var y = 0; y < counter; y++) {
          for (var item in acts[i][y]) {
            var keys = Object.keys(acts[i][y][item].groups)
            for (var k in keys) {
              if (acts[i][y][item].groups[keys[k]] && this.checkValidGroup(keys[k])) {
                temp[keys[k]][acts[i].mm][y].push(acts[i][y][item])
              }
            }
            temp['*'][acts[i].mm][y].push(acts[i][y][item])
          }
        }
      }
      this.diffs = temp

      var revices = this.metricsRevises.filter(function (metric) {
        return metric.year === Number(vm.compare)
      })
      temp = {}
      for (i in revices) {
        keys = Object.keys(revices[i].groups)
        for (k in keys) {
          if (revices[i].groups[keys[k]]) {
            temp[keys[k]] = JSON.parse(JSON.stringify(revices[i]))
          }
        }
        if (typeof temp['*'] === 'undefined') {
          temp['*'] = JSON.parse(JSON.stringify(revices[i]))
        } else {
          for (x = 0; x < 12; x++) {
            if (revices[i][x].enable) {
              for (y = 1; y < 18; y++) {
                temp['*'][x][y].value += revices[i][x][y].value
              }
              if (revices[i][x].enable) {
                temp['*'][x].enable = true
              }
            }
          }
        }
      }
      this.diffsRevises = temp
    },
    calcTygTotal () {
      for (var g in this.tempGroups) {
        var group = this.tempGroups[g].key
        for (var y = 0; y < 4; y++) {
          var sum = 0
          var sc = 0
          for (var x = 0; x < 12; x++) {
            sum += this.acts[group][x][18 + y].length
            if (this.acts[group][x][18 + y].length !== 0) {
              sc += 1
            }
          }
          if (!this.totalTygs[group]) {
            this.totalTygs[group] = []
          }
          var r = Math.floor(sum / sc)
          r = isNaN(r) || r === Infinity ? 0 : r
          this.totalTygs[group][y] = r
        }
      }
    },
    calcKpis () {
      moment.tz.setDefault('Asia/Tokyo')
      var mm = moment().month()
      mm = (mm > 2 ? mm - 2 : mm + 10) - 1
      for (var i in this.tempGroups) {
        var k0 = Math.floor(this.status[this.tempGroups[i].key][mm][9].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        var k1 = Math.floor(this.status[this.tempGroups[i].key][mm][10].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        var k2 = Math.floor(this.status[this.tempGroups[i].key][mm][11].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        this.kpidata[this.tempGroups[i].key] = {
          0: isNaN(k0) || k0 === Infinity ? 0 : k0,
          1: isNaN(k1) || k1 === Infinity ? 0 : k1,
          2: isNaN(k2) || k2 === Infinity ? 0 : k2
        }
      }
      for (i in this.tempGroups) {
        k0 = Math.floor(this.acts[this.tempGroups[i].key][mm][18].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        k1 = Math.floor(this.acts[this.tempGroups[i].key][mm][19].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        k2 = Math.floor(this.acts[this.tempGroups[i].key][mm][20].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        var k3 = Math.floor(this.acts[this.tempGroups[i].key][mm][21].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
        this.ycsdata[this.tempGroups[i].key] = {
          0: isNaN(k0) || k0 === Infinity ? 0 : k0,
          1: isNaN(k1) || k1 === Infinity ? 0 : k1,
          2: isNaN(k2) || k2 === Infinity ? 0 : k2,
          3: isNaN(k2) || k3 === Infinity ? 0 : k3
        }
      }
      for (i in this.tempGroups) {
        for (var x = 0; x < 12; x++) {
          this.okpidata[this.tempGroups[i].key] = [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ]
        }
      }
      var temp = {}
      for (i in this.tempGroups) {
        for (x = 0; x < 12; x++) {
          temp[this.tempGroups[i].key] = [
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
          ]
        }
      }

      for (i in this.tempGroups) {
        for (x = 0; x < 12; x++) {
          for (var y in this.status[this.tempGroups[i].key][x][1]) {
            var index = this.students.findIndex(s => s.key === this.status[this.tempGroups[i].key][x][1][y].key)
            if (index !== -1) {
              for (var z in this.students[index].events) {
                if (this.students[index].events[z].enable) {
                  var status = this.students[index].events[z].status
                  if (this.students[index].events[z].type !== null) {
                    status = 8 + this.students[index].events[z].type
                  }
                  if (status === 2 || status === 3) { // 2: 保護者面談 3: 体験授業 日付のあるものは実施済み
                    if (this.students[index].events[z].date1 !== null) {
                      temp[this.tempGroups[i].key][x][status].push(this.students[index].key)
                    }
                  } else {
                    temp[this.tempGroups[i].key][x][status].push(this.students[index].key)
                  }
                }
              }
            }
          }
        }
      }
      for (i in this.tempGroups) {
        for (x = 0; x < 12; x++) {
          var icount = 0
          var ecount = 0
          for (var xx = 0; xx < temp[this.tempGroups[i].key][x][2].length; xx++) {
            var xxx = temp[this.tempGroups[i].key][x][1].indexOf(temp[this.tempGroups[i].key][x][2][xx])
            if (xxx !== -1) {
              icount += 1
            }
          }
          k0 = Math.floor(icount / temp[this.tempGroups[i].key][x][1].length * 100) // 保護者面談数 / 問合せ数

          ecount = 0
          for (xx = 0; xx < temp[this.tempGroups[i].key][x][3].length; xx++) {
            xxx = temp[this.tempGroups[i].key][x][1].indexOf(temp[this.tempGroups[i].key][x][3][xx])
            if (xxx !== -1) {
              ecount += 1
            }
          }
          k1 = Math.floor(ecount / temp[this.tempGroups[i].key][x][1].length * 100) // 体験入学数 / 問合せ数
          k3 = Math.floor(temp[this.tempGroups[i].key][x][5].length / temp[this.tempGroups[i].key][x][1].length * 100) // 入塾者 / 問合せ数
          this.okpidata[this.tempGroups[i].key][x] = [
            (isNaN(k0) || k0 === Infinity ? 0 : k0),
            (isNaN(k1) || k1 === Infinity ? 0 : k1),
            // (isNaN(k2) || k2 === Infinity ? 0 : k2),
            (isNaN(k3) || k3 === Infinity ? 0 : k3),
            icount, // 保護者面談数
            ecount, // 体験入塾数
            temp[this.tempGroups[i].key][x][5].length, // 入塾数,
            temp[this.tempGroups[i].key][x][1].length // 問合せ数
          ]
        }
      }
    },
    calcKpisDiffs () {
      // moment.tz.setDefault('Asia/Tokyo')
      // var mm = moment().month()
      // mm = (mm > 2 ? mm - 2 : mm + 10) - 1
      // for (var i in this.tempGroups) {
      //   var k0 = Math.floor(this.status[this.tempGroups[i].key][mm][9].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   var k1 = Math.floor(this.status[this.tempGroups[i].key][mm][10].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   var k2 = Math.floor(this.status[this.tempGroups[i].key][mm][11].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   this.kpidata[this.tempGroups[i].key] = {
      //     0: isNaN(k0) || k0 === Infinity ? 0 : k0,
      //     1: isNaN(k1) || k1 === Infinity ? 0 : k1,
      //     2: isNaN(k2) || k2 === Infinity ? 0 : k2
      //   }
      // }
      // for (i in this.tempGroups) {
      //   k0 = Math.floor(this.acts[this.tempGroups[i].key][mm][18].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   k1 = Math.floor(this.acts[this.tempGroups[i].key][mm][19].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   k2 = Math.floor(this.acts[this.tempGroups[i].key][mm][20].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   var k3 = Math.floor(this.acts[this.tempGroups[i].key][mm][21].length / this.acts[this.tempGroups[i].key][mm][17].length * 100)
      //   this.ycsdata[this.tempGroups[i].key] = {
      //     0: isNaN(k0) || k0 === Infinity ? 0 : k0,
      //     1: isNaN(k1) || k1 === Infinity ? 0 : k1,
      //     2: isNaN(k2) || k2 === Infinity ? 0 : k2,
      //     3: isNaN(k2) || k3 === Infinity ? 0 : k3
      //   }
      // }
      var i, k0, k1, k3
      for (i in this.tempGroups) {
        for (var x = 0; x < 12; x++) {
          this.diffkpidata[this.tempGroups[i].key] = [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ]
        }
      }
      var temp = {}
      for (i in this.tempGroups) {
        for (x = 0; x < 12; x++) {
          temp[this.tempGroups[i].key] = [
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
          ]
        }
      }

      for (i in this.tempGroups) {
        for (x = 0; x < 12; x++) {
          for (var y in this.statusDiffs[this.tempGroups[i].key][x][1]) {
            var index = this.students.findIndex(s => s.key === this.statusDiffs[this.tempGroups[i].key][x][1][y].key)
            if (index !== -1) {
              for (var z in this.students[index].events) {
                if (this.students[index].events[z].enable) {
                  var status = this.students[index].events[z].status
                  if (this.students[index].events[z].type !== null) {
                    status = 8 + this.students[index].events[z].type
                  }
                  if (status === 2 || status === 3) { // 2: 保護者面談 3: 体験授業 日付のあるものは実施済み
                    if (this.students[index].events[z].date1 !== null) {
                      temp[this.tempGroups[i].key][x][status].push(this.students[index].key)
                    }
                  } else {
                    temp[this.tempGroups[i].key][x][status].push(this.students[index].key)
                  }
                }
              }
            }
          }
        }
      }
      for (i in this.tempGroups) {
        for (x = 0; x < 12; x++) {
          var icount = 0
          var ecount = 0
          for (var xx = 0; xx < temp[this.tempGroups[i].key][x][2].length; xx++) {
            var xxx = temp[this.tempGroups[i].key][x][1].indexOf(temp[this.tempGroups[i].key][x][2][xx])
            if (xxx !== -1) {
              icount += 1
            }
          }
          k0 = Math.floor(icount / temp[this.tempGroups[i].key][x][1].length * 100) // 保護者面談数 / 問合せ数

          ecount = 0
          for (xx = 0; xx < temp[this.tempGroups[i].key][x][3].length; xx++) {
            xxx = temp[this.tempGroups[i].key][x][1].indexOf(temp[this.tempGroups[i].key][x][3][xx])
            if (xxx !== -1) {
              ecount += 1
            }
          }
          k1 = Math.floor(ecount / temp[this.tempGroups[i].key][x][1].length * 100) // 体験入学数 / 問合せ数
          k3 = Math.floor(temp[this.tempGroups[i].key][x][5].length / temp[this.tempGroups[i].key][x][1].length * 100) // 入塾者 / 問合せ数
          this.diffkpidata[this.tempGroups[i].key][x] = [
            (isNaN(k0) || k0 === Infinity ? 0 : k0),
            (isNaN(k1) || k1 === Infinity ? 0 : k1),
            // (isNaN(k2) || k2 === Infinity ? 0 : k2),
            (isNaN(k3) || k3 === Infinity ? 0 : k3),
            icount, // 保護者面談数
            ecount, // 体験入塾数
            temp[this.tempGroups[i].key][x][5].length, // 入塾数,
            temp[this.tempGroups[i].key][x][1].length // 問合せ数
          ]
        }
      }
    },
    checkValidGroup (key) {
      var ret = false
      var index = this.tempGroups.findIndex(g => g.key === key)
      if (index === -1) {
        return ret
      }
      for (var i in this.tempGroups) {
        if (this.tempGroups[i].key === key) {
          ret = true
          break
        }
      }
      return ret
    },
    onShowStudents (students) {
      this.selected = students
      this.listDialog = true
    },
    onDismissed: function (value) {
      if (this.onRefreshDialog) {
        this.onRefreshDialog = false
        if (value) {
          this.onRefresh()
        }
        return
      }
      if (this.listDialog) {
        this.listDialog = false
      }
    }
  }
}
</script>

<style>
.v-btn.span {
  max-width: 14px !important;
  min-width: 14px !important;
  max-height: 32px !important;
}

.v-sheet.title-blue {
  background-color: #BBDEFB;
  border: 1px solid white;
  color: #0D47A1;
  height: 20px;
}

.v-sheet.title-green {
  background-color: #C8E6C9;
  border: 1px solid white;
  color: #1B5E20;
  height: 20px;
}

.v-sheet.title-grey {
  background-color: #F5F5F5;
  border: 1px solid white;
  color: #424242;
  height: 20px;
}

.v-sheet.title-orange {
  background-color: #FFCDD2;
  border: 1px solid white;
  color: #B71C1C;
  height: 20px;
}

.select-none {
  user-select: none;
}

.clickable {
  cursor: pointer;
  user-select: none;
}

</style>
